import PropTypes from "prop-types";
import "./style.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from "react";
import axios from 'axios';
import qs from 'qs';
import QRCode from 'qrcode';

const Home = ({ className = "" }) => {

  const [textoCopiar, setTextoCopiar] = useState('Copiar código do QR Code');
  const [buttonCopiar, setButtonCopiar] = useState(false);

  const [copia_cola, setCopiaCola] = useState('');
  const [valor, setValor] = useState('');
  const [estabelecimento, setEstabelecimento] = useState('');

  const [loading, setLoading] = useState(true);

  const [msgError,setMsgErro] = useState('')

  const [pagamentoRealizado,setPagamentoRealizado] = useState(false)

  useEffect(() => {
     pegarDadosVenda()
  }, []);

  const gerarQRCode = async (texto) => {
    try {
        const canvas = document.getElementById('qrcode'); // Canvas onde o QR Code será gerado
        await QRCode.toCanvas(canvas, texto, {
            width: 200, // Define a largura do QR Code
        });
        console.log('QR Code gerado com sucesso!');
    } catch (err) {
        console.error('Erro ao gerar QR Code:', err);
    }
};

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  function decodeBase64(encodedString) {
    try {
        return atob(encodedString);
    } catch (error) {
        return null;
    }
}

  const pegarDadosVenda = async()=>{

    var idvenda = getParameterByName('id');

    if(idvenda == null || idvenda == ''){
      
      setMsgErro('Link de pagamento inválido!')
      return false;
    }

    idvenda = decodeBase64(idvenda);
    
    let data = qs.stringify({
      'token': 'KLo-)i@CW2eJ9Kc[C[+7FB9@gJtxMsF3/-e8=O@',
      'idvenda': idvenda
    });
    
    let config = {
      method: 'post',
      url: 'https://www.xulizsistemas.com.br/painel/integracao/pix/consulta_pix_estabelecimento.php',
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data : data
    };
 

    await axios.request(config).then(function (response) {
      console.log('dados', response.data);
      
      var dados = response.data;
      if(dados.erro == "S"){
        setMsgErro(dados.mensagem)

        return false
      }

      setarDados(dados)

    }).catch(function (error) {
      console.error(error);
      alert("Encontramos um problema, certifique sua conexão e tente mais tarde")
    });
  }


  const setarDados = async (resposta)=>{
    await sleep(500)
    setLoading(false)
    await gerarQRCode(resposta.dados.qrcodestring);
 
    var valor = formatarStringParaReal(""+resposta.dados.total)

    setValor(valor)
    setEstabelecimento(resposta.dados.estabelecimento)
    setCopiaCola(resposta.dados.qrcodestring)
    
    var status = ""+resposta.dados.idvendastatus

    if(status == "2"){
      setPagamentoRealizado(true)

      document.getElementById('home_id').style.backgroundColor = "#03c353";
      document.body.style.backgroundColor = "#03c353";

      document.getElementById('valor_1').style.color = "#1c2604";
 
       
    }

  } 


  function formatarStringParaReal(valorString) {
    // Converte a string para um número
    const valorNumerico = parseFloat(valorString);

    // Formata para moeda brasileira
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(valorNumerico);
  }




  const clickCopiar = async () => {
    navigator.clipboard.writeText(copia_cola).then(() => {
      setTextoCopiar("Copiado")
      setButtonCopiar(true)
    });



    await sleep(2500)
    setTextoCopiar("Copiar código do QR Code")
    setButtonCopiar(false)
  }



  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  


  return (
    <>
      <div style={{display:loading == true ?'flex':'none',height:'100vh',alignItems:'center',justifyContent:'center',flexDirection:'column'}}>
        <img
          className="vector-icon"
          loading="lazy"
          style={{width:250,height:150}}
          alt=""
          src="/vector.svg"
        />
        <p style={{color:'white',fontSize:18,color:'#ffc800'}}>{msgError}</p>
      </div>







      <div className={`macbook-air-1`} style={{display:loading == true ?'none':'flex'}} id="home_id">
      <div className="macbook-air-1-inner">
        <div className="frame-parent">
          <div className="vector-parent">
            <img
              className="vector-icon"
              loading="lazy"
              alt=""
              src="/vector.svg"
            />
            {pagamentoRealizado == false&&(<h2 className="transfira-r-100-para-container">
              <p className="para-o-estabelecimento">
                <span>{`Transfira `}</span>
                <span className="r-100" id="valor_1">{valor}</span>
              </p>
              <p className="para-o-estabelecimento">
                para o Estabelecimento {estabelecimento}.
              </p>
            </h2>)}

            {pagamentoRealizado == true&&(<h2 className="transfira-r-100-para-container">
              <p className="para-o-estabelecimento">
                <span>{`Pagamento para o Estabelecimento `} {estabelecimento} no valor de </span>
                
              </p>
              <p className="para-o-estabelecimento">
              <span className="r-200">{valor}</span>
              <p> realizado com <span className="r-200" id="valor_2">sucesso!</span></p>
              </p>
            </h2>)}
          </div>

        </div>
      </div>
      <div className="frame-group">
        <div className="use-o-qr-code-do-pix-para-paga-parent">
        {pagamentoRealizado == false&&(<b className="use-o-qr">Use o QR Code do Pix para pagar</b>)}
          <div className="abra-o-app-em-que-vai-fazer-a-wrapper">
            {pagamentoRealizado == false&&(<b className="abra-o-app">
              Abra o app em que vai fazer a transferência, escaneie a imagem ou
              cole o código do QR Code
            </b>)}

            {pagamentoRealizado == true&&(<b className="abra-o-app">
              Transferência realizada com sucesso!
            </b>)}
          </div>
        </div>
        <div className="frame-container">
          <div className="image-1-wrapper">
           {pagamentoRealizado == false &&(<canvas id="qrcode"></canvas>)}
            {pagamentoRealizado == true&&(<img
              className="image-1-icon"
              loading="lazy"
              alt=""
              src="/image-1@2x.png"
            />)}
          </div>
          <b className="r-1001" style={{ fontSize: 20 }}>{valor}</b>



        </div>
        <div className="frame-container" style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 250, height: 50, backgroundColor: buttonCopiar ? '#61d105' : '#17333a', borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center', cursor: 'pointer' }} onClick={() => clickCopiar()}>
            <p style={{ fontSize: 14, color: 'white', marginBottom: 0 }}>{textoCopiar}
              {buttonCopiar == false && (<FontAwesomeIcon icon={faCopy} style={{ fontSize: 15, color: "white", marginLeft: 5 }} />)}
              {buttonCopiar == true && (<FontAwesomeIcon icon={faCheck} style={{ fontSize: 15, color: "white", marginLeft: 5 }} />)}

            </p>
          </div>
        </div>
      </div>
    </div>
    </>
    
  );
};

Home.propTypes = {
  className: PropTypes.string,
};

export default Home;
